import { render } from "./AIInsightsPromo.vue?vue&type=template&id=713976d4"
import script from "./AIInsightsPromo.vue?vue&type=script&lang=js"
export * from "./AIInsightsPromo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__